<app-modal-wrapper ariaRole="dialog" ariaLabelledBy="shareholders-modal-title" [ariaDescribedBy]="undefined" title="SHAREHOLDERS">
  <div class="modal-body">
    <div class="modal-body__info">
      <h2>Class: {{clientShareClassHolder().shareClass}}</h2>
      <h2>Par Value: {{clientShareClassHolder().nominalValue.displayValue}}</h2>
      <h2>Currency: {{clientShareClassHolder().currencyCode}}</h2>
    </div>

    @if (dataLoading()) {
      <app-loading-animation></app-loading-animation>
    }

    @if (dataAvailable()) {
      <div class="modal-body__content">
        <app-table-template tableTitle="Shareholders"
          [showTitle]="false"
          [showSearch]="true"
          [showToggle]="false"
          [hasCardView]="false"
          [showPagination]="true"
          [clickableRows]="false"
          [columns]="columns()"
          [currentPage]="currentPage()"
          [sortedOn]="sortField()"
          [sortDescending]="sortOrder() === -1"
          [tableMinWidthInRem]="36"
          (sortChanged)="sort($event)"
          (searchChanged)="search($event)"
          (pageChanged)="page($event)">
        </app-table-template>
      </div>
    }

    @if (dataEmpty()) {
      <div class="modal-body__empty">No shareholders available</div>
    }
  </div>
</app-modal-wrapper>
